import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Mainnav/sgds-mainnav";
import { register } from "../../utils/ce-registry";

register("sgds-mainnav", Component);

export default createComponent({
  react: React,
  tagName: "sgds-mainnav",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
